'use strict';

function translationLoader ($http) {
  return function translationLoader() {
    return $http.get('/api/core/static-text').then(translationOk);
  };

  function translationOk(response) {
    return response.data.map(byTranslation);
  }

  function translationMissing(language) {
    return language.value === null || language.key === language.value;
  }

  function byTranslation(language) {
    var translation = {};
    translation[language.key] = translationMissing(language) ? language.key : language.value;
    return translation;
  }
}

module.exports = translationLoader;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/providers/translation-loader/index.js
 ** module id = 313
 ** module chunks = 0
 **/